import { Router } from '@angular/router';
import { environment } from 'environments/environment';
var BenefitsComponent = /** @class */ (function () {
    function BenefitsComponent(router) {
        this.router = router;
        this.beneficios = [
            { descuento: '-20% Descuento', titulo: 'Sucesiones y herencias', desc: 'Te ayudamos a tramitar una herencia de principio a fin.', iconKey: 'sucesiones', ruta: 'servicios/sucesiones-y-herencias/tramitacion-de-herencia' },
            { descuento: '-20% Descuento', titulo: 'Vehículos', desc: 'Gestionamos el cambio de titularidad de tu vehículo.', iconKey: 'vehiculos', ruta: 'servicios/vehiculos/gestoria-cambio-nombre-vehiculos' },
            { descuento: '-20% Descuento', titulo: 'Pensiones', desc: 'Te ayudamos a tramitar tu pensión de jubilación.', iconKey: 'pensiones', ruta: 'servicios/laboral/tramitacion-de-jubilacion' },
            { descuento: '-20% Descuento', titulo: 'Vivienda', desc: 'Certificado energético, cédula de habitabilidad e informe técnico.', iconKey: 'certificados', ruta: 'servicios/vivienda' }
        ];
        this.descuentoGlobal = '-20% por ser cliente onLygal';
        this.subtitulo = 'Accede a servicios legales y de gestoría a precio preferente';
    }
    Object.defineProperty(BenefitsComponent.prototype, "items", {
        get: function () {
            return (this.beneficios || []).slice(0, 4);
        },
        enumerable: true,
        configurable: true
    });
    BenefitsComponent.prototype.irA = function (link) {
        this.router.navigate([link]);
    };
    /** "Ver todos los servicios" lleva al portal de servicios legales, no al listado interno. */
    BenefitsComponent.prototype.verTodosLosServicios = function () {
        window.open(environment.serviciosLegalesUrl, '_blank', 'noopener');
    };
    /**
     * URL del servicio en el portal de servicios legales. El dominio sale de
     * environment.serviciosLegalesUrl, que ya termina en barra, y la ruta del propio beneficio.
     */
    BenefitsComponent.prototype.urlDelBeneficio = function (beneficio) {
        if (!beneficio) {
            return environment.serviciosLegalesUrl;
        }
        return beneficio.ruta ? environment.serviciosLegalesUrl + beneficio.ruta : '';
    };
    /**
     * Abre el servicio en una pestaña nueva. Los beneficios sin ruta siguen llevando al listado
     * interno, para no dejar la tarjeta sin acción si se añade una sin enlace externo.
     */
    BenefitsComponent.prototype.verBeneficio = function (beneficio) {
        var url = this.urlDelBeneficio(beneficio);
        if (url) {
            window.open(url, '_blank', 'noopener');
            return;
        }
        this.router.navigate(['/benefits']);
    };
    BenefitsComponent.prototype.iconForBenefit = function (b, idx) {
        var base = 'resources/assets/images/main-page/';
        var map = {
            calendar: 'calendar-edit.svg',
            'calendar-edit': 'calendar-edit.svg',
            sucesiones: 'calendar-edit.svg',
            herencias: 'calendar-edit.svg',
            car: 'car.svg',
            coche: 'car.svg',
            vehiculo: 'car.svg',
            vehiculos: 'car.svg',
            money: 'moneys.svg',
            moneys: 'moneys.svg',
            pension: 'moneys.svg',
            pensiones: 'moneys.svg',
            book: 'archive-book.svg',
            archive: 'archive-book.svg',
            certificado: 'archive-book.svg',
            certificados: 'archive-book.svg',
            vivienda: 'archive-book.svg'
        };
        var defaults = ['calendar-edit.svg', 'car.svg', 'moneys.svg', 'archive-book.svg'];
        var key = ((b && b.iconKey) || '').toLowerCase().trim();
        for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
            var k = _a[_i];
            if (key && key.indexOf(k) !== -1) {
                return base + map[k];
            }
        }
        return base + (defaults[idx % defaults.length] || 'bag-2.svg');
    };
    return BenefitsComponent;
}());
export { BenefitsComponent };
